import { GroupSelectProps } from '@procore/core-react/dist/_typedoc/GroupSelect/GroupSelect.types.json';
import * as React from 'react';
export default {
  GroupSelectProps,
  React
};